export default __webpack_public_path__ + "static/media/Ellipse 27.4a7f21e7.svg";